export const userLeaveEnum = {
  present: 'present',
  absent: 'absent',
  weekOff: 'weekOff',
  sickLeave: 'sickLeave',
  casualLeave: 'casualLeave',
  plannedLeave: 'plannedLeave',
  unpaidLeave: 'unpaidLeave',
};
export const userLeaveLabelEnum = {
  present: 'Present',
  absent: 'Absent',
  weekOff: 'Week Off',
  sickLeave: 'Sick Leave',
  casualLeave: 'Casual Leave',
  plannedLeave: 'Planned Leave',
  unpaidLeave: 'Unpaid Leave',
};
export const userLeaveLabelEnumMapping = {
  'week off': userLeaveEnum.weekOff,
  'sick leave': userLeaveEnum.sickLeave,
  'casual leave': userLeaveEnum.casualLeave,
  'planned leave': userLeaveEnum.plannedLeave,
  'unpaid leave': userLeaveEnum.unpaidLeave,
  present: userLeaveEnum.present,
  absent: userLeaveEnum.absent,
};

export const userLeaveColorConfig = {
  [userLeaveEnum.present]: '#1F74EC',
  [userLeaveEnum.absent]: '#FF0000',
  [userLeaveEnum.weekOff]: '#FFDC6B',
  [userLeaveEnum.sickLeave]: '#2DC7FF',
  [userLeaveEnum.casualLeave]: '#9566F2',
  [userLeaveEnum.plannedLeave]: '#0EB01D',
  [userLeaveEnum.unpaidLeave]: '#FF0000',
};

export const userLeaveBalanceConfig = [
  {
    label: userLeaveLabelEnum.present,
    color: userLeaveColorConfig[userLeaveEnum.present],
    key: userLeaveEnum.present,
  },
  {
    label: userLeaveLabelEnum.absent,
    color: userLeaveColorConfig[userLeaveEnum.absent],
    key: userLeaveEnum.absent,
  },
  {
    label: userLeaveLabelEnum.weekOff,
    color: userLeaveColorConfig[userLeaveEnum.weekOff],
    key: userLeaveEnum.weekOff,
  },
  {
    label: userLeaveLabelEnum.sickLeave,
    color: userLeaveColorConfig[userLeaveEnum.sickLeave],
    key: userLeaveEnum.sickLeave,
  },

  {
    label: userLeaveLabelEnum.casualLeave,
    color: userLeaveColorConfig[userLeaveEnum.casualLeave],
    key: userLeaveEnum.casualLeave,
  },
  {
    label: userLeaveLabelEnum.plannedLeave,
    color: userLeaveColorConfig[userLeaveEnum.plannedLeave],
    key: userLeaveEnum.plannedLeave,
  },
  {
    label: userLeaveLabelEnum.unpaidLeave,
    color: userLeaveColorConfig[userLeaveEnum.unpaidLeave],
    key: userLeaveEnum.unpaidLeave,
  },
];
